// @flow
import Resource from 'speed-js-core/src/api/Resource';
import type NestedResource from 'speed-js-core/src/api/NestedResource';
import DeviceProfilesResource from './DeviceProfilesResource';

export default class DeviceResource extends Resource {
    basePath: string = 'devices/devices/';

    objectPath: string = 'devices/devices/{ident}/';

    requestAuthorisation(deviceInfo: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getBasePath()}authorise/request/`,
            'POST',
            deviceInfo,
        ).then((response) => response.data);
    }

    authorise(data: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getBasePath()}authorise/`,
            'POST',
            data,
        ).then((response) => response.data);
    }

    completeAuthorisation(deviceInfo: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getBasePath()}authorise/complete/`,
            'POST',
            deviceInfo,
        ).then((response) => response.data);
    }

    nestedResources: { [string]: Class<NestedResource> } = {
        profiles: DeviceProfilesResource,
    };
}
